module.exports = __webpack_public_path__ + "img/more_s.d3ce5f81.png";